import { ErrorStateMatcher, CanUpdateErrorStateCtor, mixinErrorState } from '@angular/material';
import { NgForm, FormGroupDirective, NgControl } from '@angular/forms';

export class AwpComponentBase {
  constructor(public _defaultErrorStateMatcher: ErrorStateMatcher,
              public _parentForm: NgForm,
              public _parentFormGroup: FormGroupDirective,
              /** @docs-private */
              public ngControl: NgControl) {}
}
export const _AwpComponentMixinBase: CanUpdateErrorStateCtor & typeof AwpComponentBase =
    mixinErrorState(AwpComponentBase);